/**
 * @file register global filters here
 * @author fuqiang15(fuqiang15@baidu.com)
 */
import {includes, defaults} from 'lodash';
import {httpsTransform} from '@/common/utils';

/**
 * 空则显示 -
 * @param {*} val - 数据
 * @param {string} text - fallback的文本
 * @param {*} empty - 认为这些值是空，其中 null 和 undefined 固定是空
 * @return {*} - 显示的值
 */
export function fallbackText(val, text = '-', empty = ['']) {
    empty = [undefined, null].concat(empty);
    return includes(empty, val) ? text : val;
}

const moneyDefaultOptions = {
    fallback: '-',
    prefix: '￥',
    empty: ['', null, undefined],
    decimals: 2
};

export function money(value, options) {
    // boolean 值不考虑，不应该是 boolean，（会显示成 0 和 1）
    options = defaults(options, moneyDefaultOptions);
    if (options.empty !== moneyDefaultOptions.empty) {
        options.empty = moneyDefaultOptions.empty.concat(options.empty);
    }
    return includes(options.empty, value) || isNaN(Number(value))
        ? options.fallback
        : `${options.prefix}${(Number(value)).toFixed(options.decimals)}`;
}

export function booleanText(val, texts = ['是', '否']) {
    return val ? texts[0] : texts[1];
}

export function https(value) {
    return httpsTransform(value);
}
export * from './dateTime';
